const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7181_16104)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7181_16104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V16H18V0Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7181_16104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23741 6.8879C6.06923 4.62993 9.29121 3.14134 10.9033 2.42212C15.5063 0.36862 16.4627 0.0119045 17.0861 0.00012559C17.2232 -0.00246506 17.5298 0.0339819 17.7284 0.206816C17.8961 0.352754 17.9422 0.549895 17.9643 0.68826C17.9864 0.826626 18.0139 1.14183 17.992 1.38811C17.7426 4.1992 16.6633 11.021 16.1142 14.1694C15.8818 15.5017 15.4244 15.9484 14.9815 15.9921C14.0189 16.0871 13.288 15.3098 12.3558 14.6543C10.897 13.6287 10.0729 12.9902 8.65691 11.9893C7.02048 10.8327 8.08131 10.1969 9.0139 9.15799C9.25797 8.8861 13.4988 4.74868 13.5809 4.37335C13.5912 4.32641 13.6007 4.15143 13.5038 4.05904C13.4069 3.96664 13.2639 3.99824 13.1606 4.02337C13.0143 4.05898 10.6839 5.71112 6.16938 8.97978C5.5079 9.46697 4.90875 9.70435 4.37193 9.69191C3.78013 9.6782 2.64175 9.33301 1.79548 9.03795C0.757494 8.67605 -0.0674757 8.48471 0.00436067 7.87009C0.0417775 7.54996 0.452793 7.22256 1.23741 6.8879Z",
    fill: "#53A4E1",
    style: {
      fill: "#53A4E1",
      fill: "color(display-p3 0.3255 0.6431 0.8824)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7181_16104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.24c324d20a165185ce713527190c63c4.svg";
export { ForwardRef as ReactComponent };